import React from "react";
import classNames from "classnames";

import styles from "./styles.module.scss";
import ResultContainer from "../../components/ResultContainer";
import LostSound from "../../../../assets/sounds/loose-sound.wav";

const LostPage: React.FC = () => {
  return (
    <div className={classNames(styles.page, "base-page")}>
      <ResultContainer
        isWon={false}
        audioSrc={LostSound}
      />
    </div>
  );
};

export default LostPage;
